import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'm-calibration-item-part',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: true,
  host: {
    '[style.width.%]': 'mPercent',
    '[style.background]': 'mColor',
    class: 'm-calibration-item-part'
  }
})
export class MCalibrationItemPartComponent {
  @Input() mColor = '#cce4fa';
  @Input() mPercent = '50';
}
